import { render, staticRenderFns } from "./TimeclockBack.template.vue?vue&type=template&id=0980ef1d&scoped=true&"
var script = {}
import style0 from "./TimeclockBack.template.vue?vue&type=style&index=0&id=0980ef1d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980ef1d",
  null
  
)

export default component.exports